import React, { useState } from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { CheckCircle2, XCircle } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export const PricingSection = () => {
  const [activeTab, setActiveTab] = useState<'base' | 'rescate' | 'completo'>('rescate');
  return <Section id="compra" darker className="!py-8 md:!py-32" data-id="element-179">
      <div className="max-w-6xl mx-auto" data-id="element-180">
        <h2 className="text-3xl md:text-5xl font-bold text-center mb-6 md:mb-16 text-white leading-tight" data-id="element-181">
          Elegí tu opción
        </h2>

        {/* Mobile Tabs */}
        <div className="flex md:hidden bg-night-800 rounded-xl p-1 mb-6 border border-night-700" data-id="element-182">
          <button onClick={() => setActiveTab('base')} className={`flex-1 py-2 text-xs font-bold rounded-lg transition-colors ${activeTab === 'base' ? 'bg-night-700 text-white shadow-sm' : 'text-gray-400 hover:text-gray-200'}`} data-id="element-183">
            BASE
          </button>
          <button onClick={() => setActiveTab('rescate')} className={`flex-1 py-2 text-xs font-bold rounded-lg transition-colors ${activeTab === 'rescate' ? 'bg-cta text-white shadow-sm' : 'text-gray-400 hover:text-gray-200'}`} data-id="element-184">
            RESCATE
          </button>
          <button onClick={() => setActiveTab('completo')} className={`flex-1 py-2 text-xs font-bold rounded-lg transition-colors ${activeTab === 'completo' ? 'bg-accent-blue text-night-900 shadow-sm' : 'text-gray-400 hover:text-gray-200'}`} data-id="element-185">
            COMPLETO
          </button>
        </div>

        <div className="grid md:grid-cols-3 gap-6 md:gap-8 mb-8 md:mb-16" data-id="element-186">
          {/* Card 1: Base */}
          <div className={`${activeTab === 'base' ? 'flex' : 'hidden'} md:flex bg-night-800 rounded-2xl md:rounded-3xl border border-night-700 p-5 md:p-8 flex-col relative`} data-id="element-187">
            <div className="absolute -top-3 md:-top-4 left-1/2 -translate-x-1/2 bg-night-700 text-gray-300 text-[10px] md:text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wider whitespace-nowrap" data-id="element-188">
              MÁS POPULAR
            </div>
            <h3 className="text-lg md:text-xl font-bold text-white mb-2 text-center mt-2 md:mt-0" data-id="element-189">
              SISTEMA BASE
            </h3>
            <div className="text-center mb-4 md:mb-6" data-id="element-190">
              <span className="text-gray-500 line-through text-sm md:text-lg mr-2" data-id="element-191">
                $39.000
              </span>
              <span className="text-3xl md:text-4xl font-bold text-white" data-id="element-192">
                $19.999
              </span>
            </div>
            <ul className="space-y-3 md:space-y-4 mb-6 md:mb-8 flex-1 text-sm md:text-base" data-id="element-193">
              <li className="flex items-start gap-2 md:gap-3" data-id="element-194">
                <CheckCircle2 className="w-4 h-4 md:w-5 md:h-5 text-accent-blue shrink-0 mt-0.5" data-id="element-195" />
                <span className="text-gray-300 leading-tight" data-id="element-196">
                  6 tomos del sistema
                </span>
              </li>
              <li className="flex items-start gap-2 md:gap-3" data-id="element-197">
                <CheckCircle2 className="w-4 h-4 md:w-5 md:h-5 text-accent-blue shrink-0 mt-0.5" data-id="element-198" />
                <span className="text-gray-300 leading-tight" data-id="element-199">
                  3 bonus exclusivos
                </span>
              </li>
              <li className="flex items-start gap-2 md:gap-3" data-id="element-200">
                <CheckCircle2 className="w-4 h-4 md:w-5 md:h-5 text-accent-blue shrink-0 mt-0.5" data-id="element-201" />
                <span className="text-gray-300 leading-tight" data-id="element-202">
                  Acceso inmediato en PDF
                </span>
              </li>
            </ul>
            <div className="mt-auto space-y-2" data-id="element-203">
              <Button href="Link de tu checkout" variant="outline" fullWidth className="!py-3 md:!py-4 !text-base md:!text-lg" data-id="element-204">
                EMPEZAR — $19.999
              </Button>
              <p className="text-center text-[10px] md:text-xs text-gray-500 font-medium" data-id="element-205">
                ⚡ Acceso inmediato
              </p>
            </div>
          </div>

          {/* Card 2: Rescate */}
          <div className={`${activeTab === 'rescate' ? 'flex' : 'hidden'} md:flex bg-night-800 rounded-2xl md:rounded-3xl border-2 border-cta p-5 md:p-8 flex-col relative transform md:-translate-y-4 shadow-[0_0_20px_rgba(108,99,255,0.2)] md:shadow-[0_0_30px_rgba(108,99,255,0.15)]`} data-id="element-206">
            <div className="absolute -top-3 md:-top-4 left-1/2 -translate-x-1/2 bg-cta text-white text-[10px] md:text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wider shadow-lg whitespace-nowrap" data-id="element-207">
              RECOMENDADO
            </div>
            <h3 className="text-lg md:text-xl font-bold text-white mb-1 md:mb-2 text-center mt-2 md:mt-0" data-id="element-208">
              SISTEMA + RESCATE
            </h3>
            <div className="text-center mb-3 md:mb-4" data-id="element-209">
              <span className="text-gray-500 line-through text-sm md:text-lg mr-2" data-id="element-210">
                $51.000
              </span>
              <span className="text-3xl md:text-4xl font-bold text-cta" data-id="element-211">
                $29.999
              </span>
            </div>
            <p className="text-center text-xs md:text-sm text-gray-400 mb-4 md:mb-6 italic leading-tight" data-id="element-212">
              "Para cuando la noche se complica y necesitás saber exactamente
              qué hacer"
            </p>
            <ul className="space-y-3 md:space-y-4 mb-6 md:mb-8 flex-1 text-sm md:text-base" data-id="element-213">
              <li className="flex items-start gap-2 md:gap-3" data-id="element-214">
                <CheckCircle2 className="w-4 h-4 md:w-5 md:h-5 text-cta shrink-0 mt-0.5" data-id="element-215" />
                <span className="text-gray-200 font-medium leading-tight" data-id="element-216">
                  Todo lo del Sistema Base
                </span>
              </li>
              <li className="flex items-start gap-2 md:gap-3" data-id="element-217">
                <CheckCircle2 className="w-4 h-4 md:w-5 md:h-5 text-cta shrink-0 mt-0.5" data-id="element-218" />
                <span className="text-white font-bold leading-tight" data-id="element-219">
                  Guía "Qué Hacer Cuando No Podés Dormir"
                </span>
              </li>
            </ul>
            <div className="mt-auto space-y-2" data-id="element-220">
              <Button href="Link de tu checkout" fullWidth className="!py-3 md:!py-4 !text-base md:!text-lg animate-pulse-slow shadow-[0_0_15px_rgba(108,99,255,0.4)]" data-id="element-221">
                QUIERO ESTE — $29.999
              </Button>
              <p className="text-center text-[10px] md:text-xs text-gray-400 font-medium" data-id="element-222">
                ⚡ Acceso inmediato
              </p>
            </div>
          </div>

          {/* Card 3: Completo */}
          <div className={`${activeTab === 'completo' ? 'flex' : 'hidden'} md:flex bg-night-800 rounded-2xl md:rounded-3xl border border-night-700 p-5 md:p-8 flex-col relative`} data-id="element-223">
            <div className="absolute -top-3 md:-top-4 left-1/2 -translate-x-1/2 bg-accent-blue text-night-900 text-[10px] md:text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wider whitespace-nowrap" data-id="element-224">
              MEJOR VALOR
            </div>
            <h3 className="text-lg md:text-xl font-bold text-white mb-1 md:mb-2 text-center mt-2 md:mt-0" data-id="element-225">
              SISTEMA COMPLETO
            </h3>
            <div className="text-center mb-3 md:mb-4" data-id="element-226">
              <span className="text-gray-500 line-through text-sm md:text-lg mr-2" data-id="element-227">
                $66.000
              </span>
              <span className="text-3xl md:text-4xl font-bold text-white" data-id="element-228">
                $39.999
              </span>
            </div>
            <p className="text-center text-xs md:text-sm text-gray-400 mb-4 md:mb-6 italic leading-tight" data-id="element-229">
              "Para dejar de llegar a la noche con la cabeza explotada"
            </p>
            <ul className="space-y-3 md:space-y-4 mb-6 md:mb-8 flex-1 text-sm md:text-base" data-id="element-230">
              <li className="flex items-start gap-2 md:gap-3" data-id="element-231">
                <CheckCircle2 className="w-4 h-4 md:w-5 md:h-5 text-accent-blue shrink-0 mt-0.5" data-id="element-232" />
                <span className="text-gray-300 leading-tight" data-id="element-233">
                  Todo lo del Sistema + Rescate
                </span>
              </li>
              <li className="flex items-start gap-2 md:gap-3" data-id="element-234">
                <CheckCircle2 className="w-4 h-4 md:w-5 md:h-5 text-accent-blue shrink-0 mt-0.5" data-id="element-235" />
                <span className="text-white font-bold leading-tight" data-id="element-236">
                  Guía "Por Qué No Podés Apagar la Cabeza y Cómo Frenarlo"
                </span>
              </li>
            </ul>
            <div className="mt-auto space-y-2" data-id="element-237">
              <Button href="Link de tu checkout" variant="secondary" fullWidth className="!py-3 md:!py-4 !text-base md:!text-lg" data-id="element-238">
                LLEVO EL COMPLETO — $39.999
              </Button>
              <p className="text-center text-[10px] md:text-xs text-gray-500 font-medium" data-id="element-239">
                ⚡ Acceso inmediato
              </p>
            </div>
          </div>
        </div>

        {/* Comparison Table - Hidden on mobile */}
        <div className="hidden md:block overflow-x-auto bg-night-800 rounded-2xl border border-night-700 p-6 md:p-8" data-id="element-240">
          <table className="w-full text-left border-collapse min-w-[600px]" data-id="element-241">
            <thead data-id="element-242">
              <tr className="border-b border-night-700" data-id="element-243">
                <th className="py-4 px-4 text-gray-400 font-semibold" data-id="element-244">
                  ¿Qué incluye?
                </th>
                <th className="py-4 px-4 text-white font-semibold text-center" data-id="element-245">
                  BASE
                </th>
                <th className="py-4 px-4 text-cta font-bold text-center" data-id="element-246">
                  RESCATE
                </th>
                <th className="py-4 px-4 text-accent-light font-bold text-center" data-id="element-247">
                  COMPLETO
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-night-700/50" data-id="element-248">
              <tr data-id="element-249">
                <td className="py-4 px-4 text-gray-300" data-id="element-250">6 Tomos del sistema</td>
                <td className="py-4 px-4 text-center" data-id="element-251">
                  <CheckCircle2 className="w-5 h-5 text-gray-500 mx-auto" data-id="element-252" />
                </td>
                <td className="py-4 px-4 text-center" data-id="element-253">
                  <CheckCircle2 className="w-5 h-5 text-cta mx-auto" data-id="element-254" />
                </td>
                <td className="py-4 px-4 text-center" data-id="element-255">
                  <CheckCircle2 className="w-5 h-5 text-accent-blue mx-auto" data-id="element-256" />
                </td>
              </tr>
              <tr data-id="element-257">
                <td className="py-4 px-4 text-gray-300" data-id="element-258">3 Bonus exclusivos</td>
                <td className="py-4 px-4 text-center" data-id="element-259">
                  <CheckCircle2 className="w-5 h-5 text-gray-500 mx-auto" data-id="element-260" />
                </td>
                <td className="py-4 px-4 text-center" data-id="element-261">
                  <CheckCircle2 className="w-5 h-5 text-cta mx-auto" data-id="element-262" />
                </td>
                <td className="py-4 px-4 text-center" data-id="element-263">
                  <CheckCircle2 className="w-5 h-5 text-accent-blue mx-auto" data-id="element-264" />
                </td>
              </tr>
              <tr data-id="element-265">
                <td className="py-4 px-4 text-gray-300" data-id="element-266">
                  Guía de rescate nocturno
                </td>
                <td className="py-4 px-4 text-center" data-id="element-267">
                  <XCircle className="w-5 h-5 text-night-700 mx-auto" data-id="element-268" />
                </td>
                <td className="py-4 px-4 text-center" data-id="element-269">
                  <CheckCircle2 className="w-5 h-5 text-cta mx-auto" data-id="element-270" />
                </td>
                <td className="py-4 px-4 text-center" data-id="element-271">
                  <CheckCircle2 className="w-5 h-5 text-accent-blue mx-auto" data-id="element-272" />
                </td>
              </tr>
              <tr data-id="element-273">
                <td className="py-4 px-4 text-gray-300" data-id="element-274">
                  Sistema anti recaída
                </td>
                <td className="py-4 px-4 text-center" data-id="element-275">
                  <XCircle className="w-5 h-5 text-night-700 mx-auto" data-id="element-276" />
                </td>
                <td className="py-4 px-4 text-center" data-id="element-277">
                  <XCircle className="w-5 h-5 text-night-700 mx-auto" data-id="element-278" />
                </td>
                <td className="py-4 px-4 text-center" data-id="element-279">
                  <CheckCircle2 className="w-5 h-5 text-accent-blue mx-auto" data-id="element-280" />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </Section>;
};